import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api.js";
import type { ContactMessage } from "../types.js";

export interface ContactListResponse {
  data: ContactMessage[];
  meta: { total: number; open: number; limit: number; offset: number };
}

export interface ContactFilters {
  q: string;
  status: "all" | "open" | "handled";
}

export function useContactMessages(filters: ContactFilters) {
  const params = new URLSearchParams();
  if (filters.q.trim()) params.set("q", filters.q.trim());
  params.set("status", filters.status);
  params.set("limit", "100");
  const search = params.toString();

  return useQuery({
    queryKey: ["contact", search],
    queryFn: () => api.get<ContactListResponse>(`/contact?${search}`),
    placeholderData: (previous) => previous,
  });
}

export function useSetContactHandled() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, handled }: { id: string; handled: boolean }) =>
      api.patch<{ data: ContactMessage }>(`/contact/${id}`, { handled }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["contact"] });
    },
  });
}

export function useDeleteContactMessage() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/contact/${id}`),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["contact"] });
    },
  });
}
